import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import GiphyStore from 'stores/GiphyStore';
import BottomDrawer from 'components/BottomDrawer/BottomDrawer';

import GiphyWrapper from '../GiphyWrapper/GiphyWrapper';


const GiphyMobile = (props) => {
  const { isDrawerOpened, closeDrawer, closePopper } = GiphyStore;
  const { handleSendButton } = props;

  useEffect(() => {
    closePopper();
  }, [closePopper]);

  return (
    <BottomDrawer opened={isDrawerOpened} onClose={closeDrawer}>
      <GiphyWrapper handleSendButton={handleSendButton} />
    </BottomDrawer>
  );
};

GiphyMobile.propTypes = { handleSendButton: PropTypes.func.isRequired };

export default observer(GiphyMobile);
